module.exports = __webpack_public_path__ + "static/avatar_alexandr_nevskyi-8e86a7467f9941480394e31938f1aa44.jpg";